import { FormControl, FormField, FormItem, FormLabel } from "@/src/components/ui/form";
import { YachtsFiltersFormT } from "./yachts-filters.schema";
import { Checkbox } from "@/src/components/ui/checkbox";

const types = [
  {
    id: "Helm",
    label: "Helm",
  },
  {
    id: "Anchor",
    label: "Anchor",
  },
] as const;

export const Brand = () => {
  return (
    <div>
      <h3 className="text-lg font-semibold col-span-full mb-4">Brand</h3>
      <FormField<YachtsFiltersFormT, "brand">
        name="brand"
        render={() => (
          <FormItem>
            {types.map((item) => (
              <FormField
                key={item.id}
                name="brand"
                render={({ field }) => {
                  return (
                    <FormItem key={item.id} className="flex flex-row items-start space-x-3 space-y-0">
                      <FormControl>
                        <Checkbox
                          className="w-6 h-6"
                          checked={field.value?.includes(item.id)}
                          onCheckedChange={(checked) => {
                            return checked
                              ? field.onChange([...field.value, item.id])
                              : field.onChange(field.value?.filter((value: string) => value !== item.id));
                          }}
                        />
                      </FormControl>
                      <FormLabel className="font-normal text-base leading-6">{item.label}</FormLabel>
                    </FormItem>
                  );
                }}
              />
            ))}
          </FormItem>
        )}
      />
    </div>
  );
};
